module.exports = __webpack_public_path__ + "img/ic_faq_konto.661902ba.svg";